//#region import libraries
import React, { useEffect, useState } from 'react';

// bootstrap
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";

// libraries
import { CustomCard } from "_atoms";
import { WeatherTile } from "_organisms";

// tremor librarues
import { ColGrid } from "@tremor/react"

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectAnalyticsStats, getNoShowCount, noShowCountOutbound, selectAnalyticsStatsStatus, resetAnalyticsStatsStatus } from "_redux/slices/prm-bookings/bookings-count";
import { selectUserDb } from "_redux/slices/main-screen/user";
import { selectDateToISO } from "_redux/slices/prm-bookings/calendar";
import { selectForecastTotal, selectForecastStatus } from "_redux/slices/security/security";

// utils
import { Colors } from "_styles";
import { selectAirlineSelectedAirport } from '_redux/slices/prm-bookings/bookings';
//#endregion

const TotalCards = (props) => {

    //#region redux
    const dispatch = useDispatch();
    const analyticsStats = useSelector(selectAnalyticsStats);
    const analyticsStatsStatus = useSelector(selectAnalyticsStatsStatus);
    const userDb = useSelector(selectUserDb);
    const analyticsDate = useSelector(selectDateToISO); // start date of the week
    const noShowCounts = useSelector(noShowCountOutbound);
    const airport = useSelector(selectAirlineSelectedAirport);
    const isSecurity = userDb?.role === "SECURITY";
    const forecastTotal = useSelector(selectForecastTotal);
    const forecastStatus = useSelector(selectForecastStatus);
    //#endregion

    //#region local states
    const [excludeNoShows, setExcludeNoShows] = useState(false);  // if true remove departure pax no shows from calendar count request

    const [depPaxNoShowCount, setDepPaxNoShowCount] = useState(0);  // if true remove departure pax no shows from calendar count request

    const [departureTotal, setDepartureTotal] = useState(0);
    const [arrivalTotal, setArrivalTotal] = useState(0);
    const [totalTotal, setTotalTotal] = useState(0);
    //#endregion

    //#region useEffect
    useEffect(() => {
        if (userDb.details.type !== "AIRLINE") dispatch(getNoShowCount({ iata: userDb.details.type === "AIRLINE" ? airport : userDb.details.authority, date: analyticsDate }));
        dispatch(resetAnalyticsStatsStatus())
    }, []);

    useEffect(() => {
        if (noShowCounts != null && noShowCounts[analyticsDate] != undefined) {
            setDepPaxNoShowCount(noShowCounts[analyticsDate]);
        }
    }, [noShowCounts, analyticsDate]);

    useEffect(() => {
        if (excludeNoShows) {

            // need to display counts including no shows
            let outboundDifference = analyticsStats.outbound - depPaxNoShowCount; // difference between count and real count
            let newTotal = analyticsStats.total - outboundDifference

            setDepartureTotal(depPaxNoShowCount);
            setArrivalTotal(analyticsStats.inbound);
            setTotalTotal(newTotal);

        }
        else {
            // need to display counts excluding no shows
            setDepartureTotal(analyticsStats.outbound);
            setArrivalTotal(analyticsStats.inbound);
            setTotalTotal(analyticsStats.total);
        }
    }, [excludeNoShows, analyticsStats]);

    // reset Analytics Stats Status
    useEffect(() => {
        if (analyticsStatsStatus == "succeeded") dispatch(resetAnalyticsStatsStatus())
    }, [analyticsStatsStatus])

    //#endregion
    const showWeather = props.showWeather && userDb.details.type != "AIRLINE" && userDb.details.type != "TRAVEL_AGENT";

    return (
        <Row className='mt-2'>
            <ColGrid numColsMd={1} numColsLg={4} gapX="gap-x-6" gapY="gap-y-6" marginTop="mt-6">
                <CustomCard title={"Departures"} data={departureTotal} isLoading={analyticsStatsStatus == "loading"} />
                {isSecurity
                    ? <CustomCard title={"Forecast"} data={forecastTotal} isLoading={forecastStatus === "loading"} decorationColor="cyan" />
                    : <CustomCard title={"Arrivals"} data={arrivalTotal} isLoading={analyticsStatsStatus == "loading"} decorationColor="green" />
                }
                {showWeather ? <WeatherTile /> : <div />}
            </ColGrid>
        </Row>
    );
};

export default TotalCards;
